/**
 * Guide link — the map's way back into the SEO guide layer.
 *
 * Every suburb with a verdict has a generated guide page at
 * /{citySlug}/{verdictId minus city prefix}/ (built by
 * scripts/generate-suburb-pages.mjs from the SAME verdict data, so the
 * mapping holds by construction). The guide pages deep-link INTO the map
 * with /app/?city=…&focus=…; this helper closes the loop in the other
 * direction so map and guide feel like one product.
 *
 * Mirrors slugFor() + CITY_REGISTRY in scripts/_load-verdicts.mjs — if the
 * registry there changes, change this too.
 */

export type GuideCityId = "hyd" | "mel" | "blr" | "syd";

const CITY_PATH: Record<GuideCityId, { path: string; prefix: string }> = {
  mel: { path: "melbourne", prefix: "mel-" },
  hyd: { path: "hyderabad", prefix: "hyd-" },
  syd: { path: "sydney", prefix: "syd-" },
  blr: { path: "bengaluru", prefix: "blr-" },
};

/** Root-relative URL of the suburb's generated guide page. */
export function guideUrlFor(verdictId: string, cityId: GuideCityId): string {
  const m = CITY_PATH[cityId];
  let slug = verdictId;
  if (slug.startsWith(m.prefix)) slug = slug.slice(m.prefix.length);
  return `/${m.path}/${slug}/`;
}
